<template>
  <img
    :src="img"
    @error="handleImageError"
    alt="" />
</template>

<script>
export default {
  props: {
    imageSrc: {
      type: String,
      default: () => ''
    }
  },
  data () {
    return {
      img: ''
    }
  },
  mounted () {
    try {
      this.img = require(`@/assets/img/carriers/${this.imageSrc}.png`)
    } catch (e) {
      this.img = ''
    }
  },
  methods: {
    handleImageError () {
      // this.$el.style = 'display:none;'
      this.$el.remove(1)
    }
  }
}
</script>
